import { InjectableService } from "@/shared/services/InjectableService";
import { AxiosResponse } from "axios";
import { QueueExecutionResponse } from "@/shared/Executions/models/QueueExecutionResponse";
import { QueueExecutionArgs } from "@/shared/Executions/models/QueueExecutionArgs";
import { QueueCustomReportsArgs } from "@/shared/Executions/models/QueueCustomReportsArgs";
import { IExecutionApiService } from "@/shared/Executions/services/ExecutionApiService";


export interface ICustomReportsApiService {
    processCustomReports: (userId: string, tenantId: string, args: QueueCustomReportsArgs) => Promise<AxiosResponse<QueueExecutionResponse>>;
}


export class CustomReportsApiService extends InjectableService implements ICustomReportsApiService {

    static readonly injectableKey = 'ICustomReportsApiService';

    get injectableKey() {
        return (this.constructor as typeof CustomReportsApiService).injectableKey;
    }

    constructor(private readonly _executionApiService: IExecutionApiService) {
        super()
    }

    public async processCustomReports(userId: string, tenantId: string, args: QueueCustomReportsArgs): Promise<AxiosResponse<QueueExecutionResponse>> {

        const qeueueExecutionArgs = new QueueExecutionArgs({ tenantId, userId, customReportArgs: args });

        return await this._executionApiService.queueExecution(qeueueExecutionArgs);
    }

}
